// Customer identity helpers for the booking flows.
//
// Identity is the signed-in Google account, so name and email are essentially
// always present (the opposite of the old phone-OTP build, where email was rare
// and phone was guaranteed). The one field Google cannot give us is the phone
// number — that comes from the operator-set booking contact in lib/contact.ts.
import { auth } from '@/lib/platform';

/** Real, deliverable email — a typed value wins, else the Google account email, else ''. */
export function customerEmail(entered?: string): string {
  return entered?.trim() || auth.currentUser?.email?.trim() || '';
}

/** Email to hand Razorpay Checkout — never Razorpay's void@ sentinel. Falls back to a
 *  WayQ-owned, uid-stable address (non-deliverable, but attributable). */
export function razorpayEmail(entered?: string): string {
  const real = customerEmail(entered);
  if (real) return real;
  return `noreply+${auth.currentUser?.uid ?? 'anon'}@wayq.in`;
}

/** Profile display name, or '' — the caller supplies the Passenger/Guest/Rider label. */
export function customerName(): string {
  return auth.currentUser?.displayName?.trim() || '';
}
